import { IconButton, Sheet, Stack, Tooltip, Typography } from "@mui/joy";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CopyAllOutlinedIcon from "@mui/icons-material/CopyAllOutlined";

const styles = {
    title: { px: 1 },
};

export default function TableInformationRow({
    numberOfRows = 0,
    onDownloadClick,
    onCopyClick,
    showDownloadCopy,
}: {
    numberOfRows?: number;
    onDownloadClick: () => void;
    onCopyClick: () => void;
    showDownloadCopy: boolean;
}) {
    return (
        <Sheet variant="soft">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography sx={styles.title} level="body-xs">
                    Table
                    {numberOfRows > 0 && ` - ${numberOfRows} row` + (numberOfRows > 1 && "s")}
                </Typography>
                {showDownloadCopy && (
                    <Stack direction="row">
                        <Tooltip title="Download" placement="top">
                            <IconButton
                                size="sm"
                                color="neutral"
                                variant="plain"
                                aria-label="Download"
                                onClick={onDownloadClick}
                            >
                                <FileDownloadOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Copy" placement="top">
                            <IconButton
                                size="sm"
                                color="neutral"
                                variant="plain"
                                aria-label="Copy"
                                onClick={onCopyClick}
                            >
                                <CopyAllOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                )}
            </Stack>
        </Sheet>
    );
}
